import React, { Component } from 'react';
//import messaging, { requestNotificationPermission } from './firebase';
import Parse from 'parse';
import $ from "jquery";
class NotificationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationToken: null,
      notification: null,
    };


    /*code*/
    
    //https://fcm.googleapis.com/fcm/send
    $.ajax({
  url: 'https://fcm.googleapis.com/v1/projects/myproject-b5ae1/messages:send',
  crossDomain: true,
  method: 'post',
  headers: {
    'Authorization': 'Bearer 641479387246-d14nc2lv0piad9a46s9i37v88dam8rg4.apps.googleusercontent.com'
  },
  contentType: 'application/json',
  // data: '{\n  "to": "YOUR_FCM_TOKEN",\n  "notification": {\n    "title": "Test Notification",\n    "body": "This is a test notification from Firebase!"\n  }\n}',
  data: JSON.stringify({
    'to': 'd5438927bc22bc2475ad454eea717b57a5919630bb7adbf58e8df1d880d429e3',
    'notification': {
      'title': 'Test Notification',
      'body': 'This is a test notification from Firebase!'
    }
  })
}).done(function(response) {
  console.log(response);
});

    /*code*/
  }

  /*async componentDidMount() {
    const token = await requestNotificationPermission();
    if (token) {
      this.saveTokenToParse(token);
    }
  }

  saveTokenToParse = async (token) => {
    const FCMToken = Parse.Object.extend('FCMToken');
    const fcmToken = new FCMToken();

    fcmToken.set('token', token);
    fcmToken.set('user', Parse.User.current());

    try {
      await fcmToken.save();
      console.log('FCM Token saved to Parse');
    } catch (error) {
      console.error('Error saving FCM Token to Parse:', error);
    }
  };*/

  render() {
    const { notification } = this.state;

    return (
      <div><br/><br/><br/><br/>
        <h1>Firebase Notifications</h1>
        {notification ? (
          <div>
            <h2>{notification.notification.title}</h2>
            <p>{notification.notification.body}</p>
          </div>
        ) : (
          <p>No new notifications</p>
        )}
      </div>
    );
  }
}

export default NotificationComponent;


// WEBPACK FOOTER //
// ./src/NotificationComponent.jsx